import { useEffect, useState } from "react";

const List = ({ integrationData, setIntegrationData }) => {
  const [lists, setLists] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    let list = integrationData?.listData?.data;
    if (list?.length > 0) {
      setLists(list);
    }
    setLoading(false);
  }, []);

  return (
    <div className="flex flex-col gap-4 xs:px-2 sm:px-4 md:px-20 h-[400px] overflow-y-scroll">
      <p>
        Select a list from the connected Klaviyo account to which new
        subscribers will be added.
      </p>
      <div className="flex flex-col gap-2">
        <label className="text-semibold text-gray-700">List Name</label>
        {loading ? (
          <div className="w-full h-8 rounded-lg bg-gray-200 animate-pulse"></div>
        ) : lists?.length > 0 ? (
          <select
            className="border-gray-200 rounded-md text-sm text-gray-500"
            value={
              integrationData?.list_id
                ? integrationData?.list_id
                : ""
            }
            onChange={(e) =>
              setIntegrationData({
                ...integrationData,
                list_id: e.target.value,
              })
            }
          >
            <option value="">Select a list</option>
            {lists?.map((list) => (
              <option key={list.id} value={list.id}>
                {list?.attributes?.name}
              </option>
            ))}
          </select>
        ) : (
          <p className="text-gray-500 text-sm">No lists found</p>
        )}
      </div>
    </div>
  );
};

export default List;
